// ─── Choisir des LIGNES prévues pour une opération (module PUR) ───
// Demandé par Cédric le 15/08 : depuis une opération, voir TOUS les budgets
// du mois avec leurs lignes (arbre), en sélectionner une à plusieurs, et
// poser sur chacune un montant ou un pourcentage.
//
// Ici les RÈGLES seulement — filtrage, regroupement, répartition par défaut.
// L'écran (`FeuilleRattacherLignes`) ne fait que les afficher.

// Clé stable d'une occurrence candidate : la ligne ET son mois.
export const cleOcc = (o) => `${o?.ligneId}|${o?.mois}`;

// Filtrer puis GROUPER les occurrences par budget, dans l'ordre des budgets ;
// les lignes sans budget en dernier — un reste à ranger, pas une catégorie.
// `recherche` porte sur le libellé de la ligne ; `sens` : tout|depense|revenu ;
// `tri` : montant (décroissant) ou nom.
export function grouperParBudget(occurrences = [], budgets = [], {
  recherche = '', sens = 'tout', tri = 'montant',
} = {}) {
  const q = String(recherche || '').trim().toLowerCase();
  const visibles = occurrences.filter(o => {
    if (!o?.ligne) return false;
    // Une occurrence ignorée ou absente ne réclame rien : la proposer comme
    // cible serait un piège.
    if (o.statut === 'ignoree' || o.statut === 'absente') return false;
    if (sens !== 'tout' && (o.ligne.sens || 'depense') !== sens) return false;
    if (q && !String(o.ligne.libelle || '').toLowerCase().includes(q)) return false;
    return true;
  });

  const ordonner = (liste) => [...liste].sort((a, b) => (tri === 'nom'
    ? String(a.ligne.libelle || '').localeCompare(String(b.ligne.libelle || ''))
    : Math.abs(b.prevu || 0) - Math.abs(a.prevu || 0)));

  const par = new Map();
  for (const o of visibles) {
    const cle = o.ligne.budgetId || null;
    if (!par.has(cle)) par.set(cle, []);
    par.get(cle).push(o);
  }
  const ordre = [...budgets.map(b => b.id), null].filter(c => par.has(c));
  return ordre.map(cle => ({
    cle,
    budget: budgets.find(b => b.id === cle) || null,
    occ: ordonner(par.get(cle)),
  }));
}

// Répartir le RESTE de l'opération sur les lignes cochées, dans l'ordre de
// sélection. Les montants SAISIS priment (c'est la volonté de l'utilisateur) ;
// la première ligne sans saisie reçoit tout ce qui reste — « 100 % du reste »
// (règle du 15/08) — et les suivantes partent de zéro, à ajuster.
// `selections` : [{ cle, saisie }] ; renvoie Map cle → montant (nombre ≥ 0).
export function repartirDefauts(selections = [], resteInitial = 0) {
  const parts = new Map();
  let reste = Math.max(0, Number(resteInitial) || 0);
  for (const s of selections) {
    if (s.saisie === '' || s.saisie == null) continue;
    const v = Math.max(0, parseFloat(String(s.saisie).replace(',', '.')) || 0);
    parts.set(s.cle, Math.round(v * 100) / 100);
    reste -= v;
  }
  for (const s of selections) {
    if (parts.has(s.cle)) continue;
    const v = Math.max(0, Math.round(reste * 100) / 100);
    parts.set(s.cle, v);
    reste -= v;
  }
  return parts;
}
